module.exports = __webpack_public_path__ + "static/media/  (180).adb360a3.jpg";